<script>
    import Papel from "./../../componentes/papel.svelte";
    import { onMount } from "svelte";
    import { replace } from "svelte-spa-router";
    import { cuenta } from "../../controlador/store";
    import UserController from "../../controlador/userController.svelte";
    let nombre = "",
        titulo = "",
        matricula = "",
        firma = "";
    let control;
    onMount(() => {});
    async function guardar() {
        await control.nuevaCuenta(
            $cuenta.user,
            $cuenta.pass,
            nombre,
            titulo,
            matricula,
            firma
        );
        replace("/home");
    }
    function base(e){
        firma = e.detail.data;
    }
</script>

<UserController bind:this={control} />
<div class="container centro">
    <div class="fila">
        <input type="text" bind:value={nombre} placeholder="Nombre">
    </div>
    <div class="fila">
        <input type="text" bind:value={titulo} placeholder="Titulo">
    </div>
    <div class="fila">
        <input type="text" bind:value={matricula} placeholder="Matricula">
    </div>
    <div class="row">
        <Papel on:base={base} />
    </div>
    <div class="fila">
        <button on:click={guardar} class="boton"><i class="ph-floppy-disk"></i> Guardar</button>
    </div>
</div>

<style>
    .centro{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
    .fila{
      width: 90%;
      max-width: 380px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cuerpo{
      width: 90%;
      max-width: 380px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input{
      width: 90%;
      max-width: 380px;
      margin-bottom: 10px;
      border: none;
      outline: none;
      border-radius: 10px;
      height: 30px;
      padding: 5px;
    }
    textarea{
      width: 90%;
      max-width: 380px;
      height: 300px;
      border-radius: 10px;
      border: none;
      outline: none;
      resize: none;
      padding: 5px;
    }
    .boton{
      margin: 10px;
      background: transparent;
      padding: 5px;
      color: white;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: none;
      cursor: pointer;
    }
    i{
      margin-top: 5px;
      font-size: 30px;
    }
  </style>